import { render } from "./TachoDriverActivityView.vue?vue&type=template&id=567362be&ts=true"
import script from "./TachoDriverActivityView.vue?vue&type=script&lang=ts"
export * from "./TachoDriverActivityView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__